export default "__VITE_ASSET__ILMfo7Ra__"